import React, {useState} from "react"
import {sendToServer} from "../BidibDataProvider";
import { CiMap } from "react-icons/ci";
import { TbMapShare } from "react-icons/tb";

const Workspace = ({data}) => {
    const [hover, setHover] = useState(false);

    const _url = "/#/s/" + data.id

    return (

        <div style={{
            padding: '10px',
            margin: '10px',
            border: '1px solid black',
            borderRadius: '5px',
            background: hover?'rgb(210,203,189)':'rgb(168,165,159)',
            color: 'rgb(27,35,54)',
            display: 'flex',
            alignItems: 'center',
            fontWeight: 'bold',
            cursor: 'pointer',
        }}
             onClick={() => {
                 window.open(_url, '_blank')
             }}
             onPointerOver={()=> setHover(true)}
             onPointerOut={() => setHover(false)}
        >
            <TbMapShare size={20}/>&nbsp;{data.id}&nbsp;{data.prettyname}
        </div>


    )

    //
}

/*
<div className={'smallIcon'} onClick={() => deleteLc(data.id)}>
                    {<FaMinus scale={0.5}/>}
                </div>
 */


export default Workspace